import React from 'react';
import { Stack } from '@mui/material';
import { TopAppBar } from './TopAppBar';
import { Footer } from './Footer';

interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {

  return (
    <Stack flexGrow={1}>
      <TopAppBar />
      <Stack flexGrow={1} component='main'>
        {children}
      </Stack>
      <Footer />
    </Stack>
  );
};